export enum MiscellaneousInformation {
  AWARDS,
  EDUCATION,
  PROF_ASSOCIATIONS,
}
